package amazon.lastmile.inject

import app.nestbridge.feature.main.ui.MainShellUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = MainShellUiFactory::class)
public interface AppNestbridgeFeatureMainUiMainShellUiFactory {
  @Provides
  @IntoSet
  public fun provideMainShellUiFactoryFactoryMultibinding(mainShellUiFactory: MainShellUiFactory): Ui.Factory = mainShellUiFactory
}
